import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

/**
 * podcastApi — the /podcast social layer (comments + likes, CEL-1355).
 * Reads are public (work logged-out); writes 401 without a session — callers
 * catch 401 and show the login CTA (persistentNavigation return rail).
 */
const podcastApi = axios.create({
  baseURL: `${config.API_BASE_URL}/cellcog/podcast`,
});

setupAxiosInterceptor(podcastApi);

/** The runtime episode registry (CEL-1362): LIVE episodes + show config —
 * replaces the build-time podcastEpisodes.js. Admin sessions also receive
 * staged episodes (isLive:false) for prod preview. A guest-preview token
 * (CEL-1751, ?preview=1&token=...) additionally returns that ONE staged
 * episode for anonymous guest review. */
export const getEpisodes = (previewToken = null) =>
  podcastApi.get('/episodes', previewToken ? { params: { token: previewToken } } : undefined);

/** Per-slug like/comment counts for hub cards. slugs: string[] */
export const getSocialCounts = (slugs) =>
  podcastApi.get('/social', { params: { slugs: slugs.join(',') } });

/** Full threaded comment list + episode like state for one episode. */
export const getComments = (slug) => podcastApi.get(`/${slug}/comments`);

/** Post a comment (or single-level reply via parentCommentId). */
export const createComment = (slug, body, parentCommentId = null) =>
  podcastApi.post(`/${slug}/comments`, {
    body,
    parent_comment_id: parentCommentId,
  });

/** Delete own comment (admins: any). */
export const deleteComment = (commentId) =>
  podcastApi.delete(`/comments/${commentId}`);

/** Toggle the episode like. */
export const toggleEpisodeLike = (slug) => podcastApi.post(`/${slug}/like`);

/** Toggle a comment like. */
export const toggleCommentLike = (commentId) =>
  podcastApi.post(`/comments/${commentId}/like`);

/** Report a comment (idempotent per user). */
export const reportComment = (commentId) =>
  podcastApi.post(`/comments/${commentId}/report`);
